import React, { useEffect, useRef, useState } from 'react'
import Popup from '../../Popup/Popup'

interface WithPopupProps {
    children?: any
    content: ({ show, openPopup }) => React.ReactElement
    onShow: () => any
    onClose: () => any
    onMount?: (context) => any
    width?: string
    height?: string
    closeOnClickInside?: boolean
    className?: string
    maxHeight?: string
    show?: boolean
    suppressPopup?: boolean
    showPopupOnMount?: boolean
}

const WithPopup = ({
    children,
    content,
    width,
    height,
    onShow,
    onClose,
    onMount,
    closeOnClickInside,
    className = '',
    maxHeight = '200px',
    show,
    suppressPopup,
    showPopupOnMount,
}: WithPopupProps) => {
    const anchor = useRef(null)
    const popupRef = useRef(null)
    const [_show, setShow] = useState(false)
    const [autoWidth, setAutoWidth] = useState('0px')

    const openPopup = (state = true) => {
        setShow(state)
    }

    const _onShow = () => {
        // e.stopPropagation()
        setTimeout(() => {
            document.addEventListener('click', handleClick)
            document.addEventListener('scroll', _onClose)

            if (onShow) {
                onShow()
            }
        }, 100)
    }

    const handleClick = (e) => {
        e.stopPropagation()
        e.preventDefault()
        // debugger
        let shallClose = false
        shallClose = !popupRef?.current?.contains(e.target) ?? false
        if (closeOnClickInside) {
            shallClose = true
        }

        if (shallClose) {
            setShow(false)
        }
        // document.removeEventListener('click', handleClose)
    }

    const _onClose = () => {
        if (onClose) {
            onClose()
        }

        if (anchor.current) {
            anchor.current.blur()
        }

        document.removeEventListener('click', handleClick)
        document.removeEventListener('scroll', _onClose)
    }

    const shallShow = show !== undefined ? show : _show

    useEffect(() => {
        if (shallShow) {
            _onShow()
        } else {
            _onClose()
        }

        if (anchor && anchor.current) {
            // @ts-ignore
            setAutoWidth(anchor?.current.getBoundingClientRect().width + 'px')
        }
    }, [shallShow])

    useEffect(() => {
        if (showPopupOnMount) {
            openPopup()
        }
        return () => {
            // document.removeEventListener('click', handleClick)
            // document.removeEventListener('scroll', _onClose)
        }
    }, [])

    const style = {
        width: width || autoWidth,
        height,
    }

    return (
        <React.Fragment>
            {children({ anchor, openPopup })}
            {suppressPopup ? null : (
                <Popup anchor={anchor} onHide={_onClose} show={shallShow} className={className} maxHeight={maxHeight}>
                    <div className='r-popup-content' style={style} ref={popupRef}>
                        {content({ show: shallShow, openPopup })}
                    </div>
                </Popup>
            )}
        </React.Fragment>
    )
}

export default WithPopup
